import React from 'react';
import { BottomNavigation as MuiBottomNavigation, Box } from '@mui/material';

import { BottomNavigationTab, BottomNavigationTabProps } from './bottom-navigation-tab.component';

export type BottomNavigationProps = {
  tabs: BottomNavigationTabProps[];
  value: string;
};

export const BottomNavigation = (props: BottomNavigationProps) => {
  const { tabs, value } = props;

  return (
    <Box pb="var(--ion-safe-area-bottom)" bgcolor="tabBar.background">
      <MuiBottomNavigation value={value} showLabels>
        {tabs.map(BottomNavigationTab)}
      </MuiBottomNavigation>
    </Box>
  );
};
